import * as React from "react";
const SvgFiRrTrademark = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-trademark_svg__a)">
      <path
        fill="#062147"
        d="M10 6c0 .55-.45 1-1 1H6v11c0 .55-.45 1-1 1s-1-.45-1-1V7H1c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1m11.94-1c-.77 0-1.47.42-1.82 1.09l-2.61 4.81-2.61-4.8a2.063 2.063 0 0 0-3.89.96V18c0 .55.45 1 1 1s1-.45 1-1V7.06l.13-.02 3.49 6.43c.35.64 1.41.64 1.76 0l3.49-6.43c.02 0 .13.03.13.02V18c0 .55.45 1 1 1s1-.45 1-1V7.06c0-1.14-.93-2.06-2.06-2.06z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-trademark_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTrademark;
